export { default } from "@/components/PostDetailsScreen";
